import React from 'react';
import { Helmet } from 'react-helmet-async';

const CookiePolicy = () => (
  <>
    <Helmet>
      <title>Cookie Policy | Nayrix</title>
      <meta name="description" content="Read Nayrix's cookie policy. We do not use cookies or tracking technologies." />
      <meta property="og:title" content="Cookie Policy | Nayrix" />
      <meta property="og:description" content="Read Nayrix's cookie policy. We do not use cookies or tracking technologies." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://nayrix.com/cookiepolicy" />
      <link rel="canonical" href="https://nayrix.com/cookiepolicy" />
    </Helmet>
    <div className="flex items-center justify-center min-h-[70vh] pt-16">
      <div className="w-full max-w-xl bg-white dark:bg-neutral-900 rounded-xl shadow-lg p-8 text-center">
        <h1 className="text-3xl font-bold mb-4">Cookie Policy</h1>
        <p className="text-lg text-neutral-600 dark:text-neutral-300">
          Nayrix does not use cookies or tracking technologies. Your browsing experience is private and secure.
        </p>
      </div>
    </div>
  </>
);

export default CookiePolicy; 